var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee_box",style:(("top: " + _vm.positionTop + "rem; width: " + _vm.width))},[(!_vm.isEnd && true)?_c('p',{ref:"area",staticClass:"marquee",class:_vm.directionClass},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }